<template>
	<div class="anjian">
		<div v-wechat-title="$route.meta.title"></div>
		<Card class='card-left'>
			<Menu mode="vertical" theme="light" :active-name="userInfo.menuList.task.children[0].key" @on-select='menuItem'>
				<MenuItem v-for="(item,index) in userInfo.menuList.task.children" :name="item.key" :key="index">
					<img :src="iconList[index]" class="menuIcon"/>
					<span style="font-weight: bold;">{{item.name}}</span>
					<div class="badge">
						<Badge v-if="item.key == 'pending_customer'" :count="userInfo.userNotice.clientTalk"></Badge>
						<Badge v-if="item.key == 'job_record'" :count="userInfo.userNotice.unreadReport"></Badge>
					</div>
				</MenuItem>
			</Menu>
		</Card>
		<div class='card-right-top'>
			<TodayCustomer v-if="menuName == 'today_customer' "></TodayCustomer>
			<PendingCustomer v-if="menuName == 'pending_customer' "></PendingCustomer>
			<JobRecord v-if="menuName == 'job_record' "></JobRecord>
		</div>
	</div>
</template>

<script>
	import PendingCustomer from './PendingCustomer.vue'
	import TodayCustomer from './TodayCustomer.vue'
	import JobRecord  from './JobRecord .vue'
	import {mapGetters} from "vuex";
	export default {
		name: "Task",
		components:{PendingCustomer,TodayCustomer,JobRecord },
		computed: {
			...mapGetters(['userInfo'])
		},
		created() {
			// 初始化菜单图标
			this.initIcon();
		},
		data() {
			return {
				menuName:'today_customer',
				iconList: []
			}
		},

		methods: {
			initIcon() {
				let that = this
				this.userInfo.menuList.task.children.forEach(function (row, index) {
					index = parseInt(index)
					that.iconList[index] = require('../../assets/icons/task/'+row.key+'.png');
				})
			},
			menuItem(e) {
				this.menuName = ''
				this.menuName = e
			}
		}
	}
</script>

<style scoped  lang="less">
	.text-center{
		height: 580px;
		overflow: scroll;
	}
	.shijian{
		position: relative;
		left: 15px;
	}
	.xiaoxi{
		position: relative;
		left: -120px;
		top: 18px;
	}
	.icon-biao{
		display: flex;
		justify-content: left;
		font-size: 15px;
		margin-bottom: 30px;
	}
	.xiangqing{
		background-color: #F9FAFA;
	}
	.biaoti{
		font-weight: bold;
	}
	.biaogetoubu{
		background-color: #F9FAFA;
		border-bottom: 1px solid #E8EAEC;
	}
	.shuju{
		margin-bottom: 10px;
		text-align: left;
		text-align-last: justify;
		display: flex;
		justify-content: left;
		div{
			margin-right:20px ;
			width: 60px;
		}
	}
	.biaogelimian{
		display: flex;
		justify-content: space-around;
	}
	.shanchu{
		margin-right: 10px;
		color: #54A1F3;
		font-size: 15px;
	}
	.biaotou{
		display: flex;
		justify-content: space-between;
	}

	.xinjianbottom {
		margin-top: 60px;
		display: flex;
		justify-content: left;
	}

	

	.dialoglist {
		display: flex;
		justify-content: left;
		align-items: center;
		margin-bottom: 20px;
	}

	.assign {
		position: relative;
		left: 80%;
		top: -232px;
	}

	.top-add {
		position: relative;
		width: 30px;
		left: 80%;
		bottom: 30px;
	}

	.input-text {
		margin-top: 30px;
		display: flex;
		justify-content: left;
		align-items: center;

		div {
			margin: 0 10px;
		}
	}

	.top-save {
		position: relative;
		left: 70%;
		top: -30px;
	}

	.cascader {
		width: 380px;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;

		.child-div {
			width: 60px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.chongzhi {
		position: absolute;
		top: 16px;
		left: 280px;
	}

	.sousuo {
		height: 32px;
		width: 100%;
		margin-bottom: 20px;
	}
	.ivu-table-fixed-header thead tr th{
		text-align: center;
	}
	.badge{
		position: absolute;
		width: 50px;
		height: auto;
		top: 30%;
		right: 10%;
	}
	.menuIcon{
		display: inline-block;
		width: 15px;
		height: 15px;
		vertical-align: middle;
		margin-bottom: 3px;
		margin-right: 5px;
	}
</style>
